module.exports = __webpack_public_path__ + "img/searchIcon.f9ecfe19.svg";